import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {ExtraSearchModel} from "../extra-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {ExtraSearchPageComponent} from "../extra-search-page/extra-search-page.component";
import {ExtraEditPageComponent} from "../extra-edit-page/extra-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-extra-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        provideSearchModel(ExtraSearchModel),
        registerSelectEditControl(ExtraSingleSelectEditControlComponent)
    ]
})
export class ExtraSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ExtraSearchModel> {
    constructor(model: ExtraSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = ExtraSearchPageComponent;
        this.extendedEditComponent = ExtraEditPageComponent;
    }
}
